export default "__VITE_ASSET__f6909c43__"